import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "currentColor",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12.083 4.083a1.82 1.82 0 1 0 0 3.642 1.82 1.82 0 0 0 0-3.642M2.29 6.653h6.557a3.322 3.322 0 0 0 6.471 0h2.389a.75.75 0 0 0 0-1.5h-2.389a3.322 3.322 0 0 0-6.471 0H2.29a.75.75 0 1 0 0 1.5m2.392 6.693H2.29a.75.75 0 0 0 0 1.5h2.39a3.322 3.322 0 0 0 6.472 0h6.554a.75.75 0 1 0 0-1.5h-6.554a3.322 3.322 0 0 0-6.471 0m5.056.75a1.82 1.82 0 1 0-3.641 0 1.82 1.82 0 0 0 3.641 0",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }